export default "__VITE_ASSET__DmR0f3E9__"